import { FormGroup } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { useFormValues } from '@s20/components/forms/FormContext';
import {
    ConfirmationStatus, getJobStartTime, JobAssignmentCancellationTypes,
} from '../../../../../dispatch/Dispatch';
import ValidatedSelect from '../../../../../common/forms/ValidatedSelect';
import Input from '../../../../../common/forms/Input';
import { Textarea } from '../../../../../common/forms/FormElements';

export const CancelJobAssignmentBody = ({
    assignment, jobAssignmentCancellationTypes, day, job,
}) => {
    const values = useFormValues();

    const jobAssignmentCancellationType = jobAssignmentCancellationTypes.find(
        (jact) => jact.id == values.selectedJobAssignmentCancellationType,
    );

    const selectedJobAssignmentCancellationTypePreventsReassignment = Boolean(
        jobAssignmentCancellationType && jobAssignmentCancellationType.preventsReassignment,
    );

    return (
        <>
            <FormGroup>
                <label>{`Job Start Time: ${getJobStartTime({ day, job })}`}</label>
            </FormGroup>

            <ValidatedSelect
                required
                placeholder="Select Cancellation Reason"
                id="selectedJobAssignmentCancellationType"
                name="selectedJobAssignmentCancellationType"
                label="Cancellation Reason"
                isClearable
                options={jobAssignmentCancellationTypes}
                getOptionLabel={(option) => option.description}
                getOptionValue={(option) => option.id}
                valueField="id"
                error="Please select a cancellation reason"
            />

            {selectedJobAssignmentCancellationTypePreventsReassignment && (
                <div className="mb-2 text-danger">
                    <FontAwesomeIcon icon={faInfoCircle} />

                    Selecting this will prevent the employee from
                    being reassigned for the remainder of the day.
                </div>
            )}

            {(values.selectedJobAssignmentCancellationType ?? {}) === JobAssignmentCancellationTypes.ClientCancel
                && assignment.confirmationStatusId === ConfirmationStatus.NoResponse ?
                (
                    <small className="text-danger">
                        Assignment needs to be confirmed for client cancellation.
                    </small>
                ) : (
                    <>
                        <Input
                            label="Cancellation Time"
                            id="selectedJobAssignmentCancellationTime"
                            type="datetime-local"
                            required
                            name="selectedJobAssignmentCancellationTime"
                            error="Cancellation Time is required."
                        />

                        <Textarea
                            label="Notes"
                            id="notes"
                            name="selectedJobAssignmentCancellationNotes"
                            placeholder="Enter optional notes regarding the cancellation."
                            maxLength="500"
                            rows="5"
                        />
                    </>
                )}
        </>
    );
};